// document.querySelectorAll(".department-hour-icon").forEach((icon) => {
// 	icon.addEventListener("click", function () {
// 		this.classList.toggle("icon-active");
// 	});
// });

"use strict";

var $ = jQuery;

function initDepartmentHoursToggle() {
	var $departmentBtn,
		$departmentContent,
		$departmentIcon;

	$departmentBtn = $(".department-hour-btn");

	if (!$departmentBtn.length) {
		return;
	}

	$departmentContent = $(".department-hour-content");
	$departmentIcon = $(".department-hour-icon");

	$departmentBtn.on("click", function () {
		var $content = $(this).next($departmentContent);

		// Toggle the content with a slide-down/up effect
		$content.slideToggle(300); // 300ms for the slide-down/up animation

		// Toggle the active class on the button icon
		$(this).find($departmentIcon).toggleClass("icon-active");
	});

	// $departmentIcon.each(function () {
	// 	$(this).on("click", function () {
	// 		$(this).toggleClass("icon-active");
	// 	});
	// });
}

// Initialize the Department Hours Toggle
$(initDepartmentHoursToggle);